import React, { Component } from 'react';

import Header from 'components/Header';
import Footer from 'components/Footer';
import CustomSwiper from 'components/CustomSwiper';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import { productsSwiperSettings } from 'configs/productsSwiperSettings';
import * as commonService from 'services/commonService';

class Homepage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			homeData: null
		};

		document.documentElement.scrollTop = 0;
		document.body.scrollTop = 0;

		commonService.onLoadFunction();
	}

	componentDidMount() {
		this.props.setHomeDataLoader(true);
		this.props.getHomeData();
	}
	componentDidUpdate() {
		if (!this.state.homeData && this.props.homeData) {
			this.setState({ homeData: this.props.homeData });
		}
	}
	render() {
		const { loadingHomeData } = this.props;
		const { homeData } = this.state;

		return (
			<div className="homepage">
				<Header history={this.props.history} from="home" />

				{/* Banner Section Start */}
				<div className="d-flex align-items-center justify-content-center py-3 banner">
					<img src={require('assets/imgs/homeBanner.png')} alt="" />
				</div>
				{/* Banner Section End  */}

				{loadingHomeData ? (
					<div className="w-100 py-5 text-center">
						<h1>Loading...</h1>
					</div>
				) : (
					<div style={{ background: '#F7FBFF' }} className="pt-1 pb-3">
						{homeData &&
							homeData.results &&
							homeData.results.length > 0 &&
							homeData.results.map((data, index) => (
								<div className="px-1 px-md-4" key={index}>
									{data &&
									data.products &&
									data.products.length > 0 && (
										<div style={{ marginTop: index !== 0 ? 34 : 0 }} key={index}>
											<CustomSwiper
												data={data}
												settings={productsSwiperSettings}
												history={this.props.history}
											/>
										</div>
									)}
								</div>
							))}
					</div>
				)}

				<div className="w-100 explore">
					<div className="py-4 py-md-5">
						<div className="container p-0">
							<div className="row m-0">
								<div className="col-md-6 col-lg-5 d-flex justify-content-center">
									<img src={require('assets/imgs/explore.jpg')} alt="" className="mw-100" />
								</div>
								<div className="col-md-6 col-lg-7 details mt-4 mt-md-2">
									<h3>Meoan Organics brings</h3>
									<h1>World Class Quality Products</h1>
									<h4>@ your door step</h4>
									<button
										className="my-4 my-md-5"
										onClick={() => this.props.history.push('/category/someID')}
									>
										Explore our Products
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="stores px-2 px-sm-3 px-md-5 pt-4 pb-3 pt-md-5 pb-md-5 mb-3">
					<div className="store">
						<p className="sub-title m-0 ml-1 ml-md-2" style={{ opacity: 0.7 }}>
							Come explore our
						</p>
						<h6 className="large-title ml-1 ml-md-2" style={{ opacity: 0.8 }}>
							Store
						</h6>
						<div className="w-100 row m-0">
							<div className="col-md-6 px-1 px-md-3">
								<img src={require('assets/imgs/store.png')} alt="store" className="w-100" />
							</div>
							<div className="col-md-6 px-1 px-md-3 d-flex align-items-center justify-content-center">
								<div className="d-flex flex-row align-items-start my-3 my-md-2 px-0 px-lg-5">
									<img
										src={require('assets/imgs/gpsIcon.svg')}
										alt="store"
										className="location-icon"
									/>
									<div className="ml-2">
										<h6 className="location">Manikonda</h6>
										<p className="addrs">
											Plot 37/c, Lanco Hills Road, Opp Lanco Hanging Gardens, Manikonda,
											Hyderabad, Telangana 500032
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<Footer />
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getHomeData: Actions.getHomeData,
			setHomeDataLoader: Actions.setHomeDataLoader
		},
		dispatch
	);
}
function mapStateToProps(reducer) {
	const homeReducer = reducer.homeReducer;
	return {
		loadingHomeData: homeReducer.loadingHomeData,
		homeData: homeReducer.homeData
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(Homepage);
